const IsLoading = () => {
    return <div className='is-loading'><p>Đang xử lý</p></div>;
};
export default IsLoading;
